import React from 'react';
import LocationTemplate from './LocationTemplate';

const BroadwayPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Broadway"
      stateName="North Carolina"
      countyName="Lee"
      zipCodes={["27505"]}
      latitude={35.4559}
      longitude={-79.0541}
      population={1267}
      historicalFact="Small town in Lee County."
      nearbyTowns={[
        "Sanford, NC",
        "Siler City, NC",
        "Pittsboro, NC",
        "Carthage, NC",
        "Cameron, NC",
        "Apex, NC",
        "Southern Pines, NC",
        "Aberdeen, NC"
      ]}
    />
  );
};

export default BroadwayPage;